<template>
  <v-carousel v-model="model" height="250px" class="rounded-xxl"
    hide-delimiter-background interval="4000" cycle>
      <v-carousel-item v-for="(item, key) in data" :key="key">
        <v-img
            :src="item.avatar?.includes('.pdf')? `/static/document_background.jpg`: item.avatar"
            cover height="250px"
            gradient="to top right, rgba(0,0,0,0.3), rgba(0,0,0,0.7)"
            class="absolute inset-0" 
          >

            <!-- Foreground content -->
            <div class="pa-8" style="position: absolute; top: 0; left: 0; z-index: 2; width: 100%; height: 250px;pointer-events: none;">
              <v-sheet class="d-flex flex-column" style="height: 100%;" color="transparent">
                <h3 class="white--text">{{ item.title }}</h3>
                <p class="white--text brief-carousel"  style="max-height: 72px;overflow: hidden;" v-html="item.brief"></p>
                <div style="width: 100%; pointer-events:auto;" class="d-flex justify-end mt-auto mb-5">
                  <v-btn dark color="black" class="rounded-xl mr-5" style="text-transform: none; color: white;"  @click="viewModal = true, selected = item"> Đọc tin </v-btn>
                </div>
              </v-sheet>
            </div>
          </v-img>
      </v-carousel-item>
      
      <v-dialog v-model="viewModal" width="600px" class="rounded-xl">
        <v-card v-if="selected" class="rounded-xl">
          <v-card-title class="text-subtitle-1" style=" word-break: normal;">
            {{ selected?.title }}
          </v-card-title>
          <v-img v-if="!selected.avatar?.includes('.pdf')" :src="selected.avatar"></v-img>
          <iframe v-else
            :src="selected.avatar"
            style="width:100%; height:500px; border:none;"
        ></iframe>
          <v-card-text v-show="!!selected?.brief" >
            <span v-html="selected?.brief"></span>
          </v-card-text>
          <v-card-actions>

          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- pop up -->
      <v-dialog v-model="popNewsDialog" width="900" >
        <v-card dark>
          <v-carousel class="rounded" height="auto"
            delimiter-icon="mdi-minus"
            hide-delimiter-background hide-delimiters
            show-arrows-on-hover cycle interval="4000">
            <v-carousel-item v-for="(item, key) in data" :key="key">
              <v-card>
                <v-img min-height="500px" style="max-height: calc(100vh - 300px);" width="900" class="d-flex align-end" :src="item.avatar" cover position="top center">
                  <template v-slot:placeholder><img style="width:900px" src="/static/document_background.jpg" alt=""></template>
                  <v-card tile dark style="background-color:rgba(0, 0, 0, 0.4);">
                    <v-card-title class="white--text" style=" word-break: normal;">
                      {{item.title}}
                      <v-spacer></v-spacer>
                      <!-- <v-btn dark :to="{name:'NewsDetail', params: { id: n.code }}">Chi tiết...</v-btn> -->
                    </v-card-title>
                    <v-card-subtitle></v-card-subtitle>
                    <v-card-text>
                      <span v-html="item.brief"></span>
                    </v-card-text>
                  </v-card>
                </v-img>
              </v-card>
            </v-carousel-item>
          </v-carousel>
        </v-card>
      </v-dialog>
    </v-carousel>
</template>

<script>
export default {
  name: "slider",
  props: ["data"],
  data() {
    return {
      // sliders: [],
      // news: []
      viewModal: false,
      selected: null,
      popNewsDialog: true,
    }
  },
}
</script>

<style scoped>
::v-deep .brief-carousel a {
    color: white !important;
  }
</style>